module.exports = __webpack_public_path__ + "img/change.0760d349.svg";